import { useMutation } from "@tanstack/react-query";

import type { IActivationAgentFormDTO } from "app/pages/sales-intelligence/modules/onboarding/types/form-value";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useSubmitActivationAgentForm = () => {
    return useMutation({
        mutationFn: (form: IActivationAgentFormDTO): Promise<void> => {
            return salesApiService.onboarding.submitActivationAgentForm(form);
        },
    });
};
